import { O as l, E as r, T as s } from "./legend-5216905c-c7014324.js";
import "./abstract-base-0be59b32-472aea73.js";
import { d as o } from "./unsafe-svg-7963a9ae-a1571060.js";
import { c as b } from "./legend-circle-0e9cbc84-7a23b644.js";
var a = /* @__PURE__ */ ((e) => (e.CIRCLE = "circle", e.TRIANGLE = "triangle", e.SQUARE = "square", e.DIAMOND = "diamond", e.TRIANGLE_DOWN = "triangle-down", e))(a || {});
const v = " ";
function w(e, t = v) {
  return typeof t != "string" && (t = v), e == null ? void 0 : e.split(t).map((n) => n.trim());
}
const m = {
  seriesName: "series",
  beaconLegendName: "beacon-legend",
  beaconLegendItemName: "beacon-legend-item",
  beaconTableName: "beacon-table",
  deselectedClassName: "deselected",
  pointActiveState: "normal",
  pointInactiveState: "inactive",
  beaconNestedComponents: ["beacon-legend", "beacon-legend-item", "beacon-table", "beacon-chart-tooltip"],
  highchartsASTTags: ["beacon-chart-tooltip", "beacon-chart-tooltip-data"],
  highchartsASTAttributes: ["label", "value", "index", "color", "subset", "variant", "uuid", "tooltip-title", "disable-title"],
  defaultLegendLayout: {
    vertical: l.TOP,
    horizontal: r.CENTER,
    direction: s.HORIZONTAL
  },
  exportMenuItems: ["viewFullscreen", "printChart", "separator", "separator", "downloadCSV"],
  // Conditional export menu item when charts don't have an HTML table already.
  exportMenuViewDataLabel: "viewData",
  // Because CDT tokens do not translate to JS tokens, these are defined on their own
  titleSpacers: {
    small: 16,
    large: 24
  },
  decimalNumber: 10,
  captionMargin: 24
}, f = `<svg slot="icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <rect y="5" width="7.0711" height="7.0711" transform="rotate(-45 0 5)"/>
</svg>`, L = `<svg slot="icon" height="10px" width="10px" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <rect width="10" height="10"/>
</svg>`, N = `<svg slot="icon" width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>`, T = `<svg slot="icon" width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>`, i = {
  circle: o(b),
  triangle: o(N),
  square: o(L),
  diamond: o(f),
  triangleDown: o(T)
};
function R(e) {
  if (!e)
    return m.defaultLegendLayout;
  const t = w(e);
  return t ? {
    vertical: t.find((n) => Object.values(l).includes(n)) || l.TOP,
    horizontal: t.find((n) => Object.values(r).includes(n)) || r.CENTER,
    direction: t.find((n) => Object.values(s).includes(n)) || s.HORIZONTAL
  } : m.defaultLegendLayout;
}
function C() {
  const e = this.dataTableDiv.querySelector("table");
  if (!e)
    return;
  const t = document.createElement(this.userOptions.plotOptions.custom.tableElement);
  this.dataTableDiv.appendChild(t), t.appendChild(e);
}
function E(e) {
  const t = [...Object.values(a)], n = e % t.length;
  return t[n];
}
function D(e) {
  switch (E(e)) {
    case a.CIRCLE:
      return i.circle;
    case a.TRIANGLE:
      return i.triangle;
    case a.SQUARE:
      return i.square;
    case a.DIAMOND:
      return i.diamond;
    case a.TRIANGLE_DOWN:
      return i.triangleDown;
    default:
      return i.circle;
  }
}
function S(e) {
  var t, n, c, d, u, g;
  if (e.series.length >= 2) {
    const h = (c = (n = (t = e.series[0]) == null ? void 0 : t.points[0]) == null ? void 0 : n.graphic) == null ? void 0 : c.symbolName, p = (g = (u = (d = e.series[1]) == null ? void 0 : d.points[0]) == null ? void 0 : u.graphic) == null ? void 0 : g.symbolName;
    return h && p ? h !== p : !0;
  }
  return !1;
}
export {
  C as E,
  S as R,
  D as S,
  a,
  m as p,
  w as v,
  R as y
};
